module.exports = __webpack_public_path__ + "static/media/wordmark.7ac78ea2.png";